<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/ticket-template"
                saveRoot="/ticket-template"
                @onTrashClick="onTrashClick"
                :formStructure="dataFormStructures.template">
            <slot slot="ticketPreview">
                <div class="text-right mb-3">
                    <b-button @click="onTicketPreviewClick" class="btn btn-light btn-sm">
                        {{Core.Definition.getDefinition('Actualiser')}}
                    </b-button>
                </div>
                <Request
                        ref="requestTicketPreview"
                        method="POST"
                        root="/ticket-template/preview"
                        :onRequestSuccess="onRequestSuccessTicketPreview">
                    <slot slot="body">
                        <div v-html="dataTicketPreview"></div>
                    </slot>
                </Request>
            </slot>
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/ticket-template"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression du gabarit')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce gabarit?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    import Modal from '../../components/Modal'
    import InputCheckbox from '../../components/InputCheckbox'
    import Request from '../../components/Request'

    export default {
        name: 'TicketTemplate',
        components: {
            DynamicForm,
            ModalTrash,
            Modal,
            InputCheckbox,
            Request
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataTicketPreview: '',
                dataFormStructures: {
                    template: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Gabarit'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'description'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Apparence'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logo'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logoWidth'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'primaryColor'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'secondaryColor'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'bgColor'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'bgImage'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'bgOverlayColor'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Texte'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'header'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'subHeader'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'terms'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cards: [
                                            {
                                                key: 'ticketPreview',
                                                caption: Core.Definition.getDefinition('Prévisualiser')
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'title',
                                type: 'longText',
                                label: Core.Definition.getDefinition('Description'),
                                value: ''
                            },
                            {
                                id: 'header',
                                type: 'text',
                                label: Core.Definition.getDefinition('Entête'),
                                value: ''
                            },
                            {
                                id: 'subHeader',
                                type: 'text',
                                label: Core.Definition.getDefinition('Sous-entête'),
                                value: ''
                            },
                            {
                                id: 'terms',
                                type: Core.Value.typeLongText,
                                label: Core.Definition.getDefinition('Termes et conditions'),
                                value: ''
                            },
                            {
                                id: 'primaryColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Couleur primaire'),
                                value: {}
                            },
                            {
                                id: 'secondaryColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Couleur secondaire'),
                                value: {}
                            },
                            {
                                id: 'bgColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Couleur arrière-plan'),
                                value: {}
                            },
                            {
                                id: 'bgImage',
                                type: 'image',
                                label: Core.Definition.getDefinition('Image arrière-plan'),
                                placeholder: Core.Definition.getDefinition('Téléversez une image d\'arrière plan'),
                                value: []
                            },
                            {
                                id: 'bgOverlayColor',
                                type: Core.Value.typeColor,
                                mode: 'sketch',
                                label: Core.Definition.getDefinition('Couleur superposée à l\'image'),
                                value: {}
                            },
                            {
                                id: 'logo',
                                type: 'avatar',
                                label: Core.Definition.getDefinition('Logo'),
                                value: '',
                                cropperOptions:{
                                    movable: true,
                                    zoomable: true
                                }
                            },
                            {
                                id: 'logoWidth',
                                type: 'text',
                                label: Core.Definition.getDefinition('Largeur du logo'),
                                description: Core.Definition.getDefinition('EX: 100px ou 40%'),
                                value: ''
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/evenement/evenements')
            },
            clickEdit() {
            },
            onTicketPreviewClick() {
                let form = this.$refs.dynamicForm.$refs.form.form
                this.$refs.requestTicketPreview.clearArgs()
                this.$refs.requestTicketPreview.addArg('header', form.header, Core.Value.typeText)
                this.$refs.requestTicketPreview.addArg('subHeader', form.subHeader, Core.Value.typeText)
                this.$refs.requestTicketPreview.addArg('primaryColor', form.primaryColor, Core.Value.typeColor)
                this.$refs.requestTicketPreview.addArg('bgColor', form.bgColor, Core.Value.typeColor)
                this.$refs.requestTicketPreview.addArg('secondaryColor', form.secondaryColor, Core.Value.typeColor)
                this.$refs.requestTicketPreview.addArg('bgOverlayColor', form.bgOverlayColor, Core.Value.typeColor)
                this.$refs.requestTicketPreview.addArg('terms', form.terms, Core.Value.typeLongText)
                this.$refs.requestTicketPreview.addArg('logo', form.logo, Core.Value.typeAvatar)
                this.$refs.requestTicketPreview.addArg('logoWidth', form.logoWidth, Core.Value.typeText)
                if (form.bgImage[0] !== undefined && form.bgImage[0].src !== undefined) {
                    this.$refs.requestTicketPreview.addArg('bgImage', form.bgImage[0].src, Core.Value.typeText)
                }
                this.$refs.requestTicketPreview.request()
            },
            onRequestSuccessTicketPreview(data){
                if (data.preview !== undefined) {
                    this.dataTicketPreview = data.preview
                }
            }
        }
    }
</script>
